<template>
  <div>
    <div class="row">
      <div class="col mt-4">
        <h3>{{ $t('SETTINGS.TITLE.PAGES_CUSTOM_DOMAIN_SETUP') }}</h3>
      </div>
    </div>
    <form @submit.prevent="updateCustomDomain">
      <div class="row mt-3">
        <div class="col align-self-end">
          <label for="custom-domain">{{
            $t('SETTINGS.LABEL.PAGES_CUSTOM_DOMAIN')
          }}</label>
          <input
            type="text"
            class="form-control mr-3"
            v-model="customDomain"
            id="custom-domain"
            :disabled="domainSet"
          />
          <div class="invalid-feedback d-block" v-show="customDomainError">
            {{ customDomainError }}
          </div>
        </div>
        <div class="col pt-4">
          <HMButton
            class="btn-primary"
            type="submit"
            v-if="!domain"
            :loading="domainInProgress"
          >
            {{ $t('SETTINGS.BUTTON.APPLY') }}
          </HMButton>
          <HMButton
            class="btn-primary"
            v-if="domain"
            :loading="domainInProgress"
            @click="deleteCustomDomain"
          >
            {{ $t('SETTINGS.BUTTON.REMOVE') }}
          </HMButton>
        </div>
      </div>
      <div class="row mt-3" v-if="domain">
        <div class="col" v-if="domain.success">
          <h5>{{ $t('SETTINGS.TEXT.SET_CNAME') }}</h5>
          <p>{{ domain.cname }}</p>
        </div>
        <div class="col" v-if="!domain.success">
          <span class="text-danger">
            {{ $t('SETTINGS.TEXT.ERROR_CUSTOM_DOMAIN') }}
          </span>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'PagesCustomDomain',
  components: {},
  computed: {
    ...mapGetters({
      domain: 'setting/pagesDomain',
      teacher: 'user/teacher',
    }),
    isDomainValid() {
      return (
        this.domain?.success &&
        this.domain?.heroku_response?.content.acm_status === 'cert issued' &&
        this.domain?.heroku_response?.content.acm_status_reason === ''
      );
    },
  },
  data() {
    return {
      inProgress: false,
      studioURL: null,
      studioURLError: null,
      customDomainError: null,
      customDomain: null,
      domainInProgress: false,
      domainSet: false,
    };
  },
  methods: {
    async updateCustomDomain() {
      this.domainInProgress = true;
      try {
        this.customDomainError = null;
        const domain_resp = await this.$store.dispatch(
          'setting/setPagesDomain',
          {
            domain: this.customDomain,
          }
        );
        this.domainSet = true;
        if (!this.isDomainValid) {
          this.customDomainError =
            domain_resp?.heroku_response?.content?.acm_status_reason;
        }
      } catch (error) {
        this.customDomainError = error?.response?.data?.parameters?.domain?.[0];
      }
      this.domainInProgress = false;
    },
    async getCustomDomain() {
      try {
        const domain_resp = await this.$store.dispatch(
          'setting/getPagesDomain'
        );
        this.customDomain = this.domain.domain;
        this.domainSet = true;
        if (!this.isDomainValid) {
          this.customDomainError =
            domain_resp?.heroku_response?.content?.acm_status_reason;
        }
      } catch (error) {
        this.customDomainError = error.response?.data;
      }
    },
    async deleteCustomDomain() {
      this.domainInProgress = true;
      try {
        await this.$store.dispatch('setting/deletePagesDomain');
        this.customDomain = null;
        this.domainSet = false;
      } catch (error) {
        this.customDomainError = error.response?.data;
      }
      this.domainInProgress = false;
    },
  },
  mounted() {
    this.getCustomDomain();
  },
});
</script>
